@if (!headerReady) {
<global-header-skeleton></global-header-skeleton>
} @else {
<div class="header">
  <div class="-left-side">
    <div class="-logo-container">
      <a [routerLink]="'/'">
        <site-logo [type]="'global'"></site-logo>
      </a>
    </div>
    @if (showNavMenu) {
    <div class="-main-nav-container">
      <app-header-nav [menu]="menu"></app-header-nav>
    </div>
    }
  </div>
  <div class="-right-side">
    <div class="quick-links-container-lg-screen">
      <span class="-search-container">
        <!-- <search-form (expandedChange)="onSearchExpand($event)"></search-form> -->
        <app-devsite-search (expandedChange)="onSearchExpand($event)"></app-devsite-search>
      </span>
      <div class="quick-links -announcement">
        <span class="-announcement-link">
          <lucide-icon name="bell"></lucide-icon>
        </span>
        <span class="dark-mode-toggle">
          <lucide-icon
            (click)="switchThemeMode()"
            [name]="theme === 'light' ? 'moon' : 'sun'"
            role="button"
            tabindex="0"
            aria-label="Toggle dark mode"></lucide-icon>
        </span>
        @if (supportMenu) {
        <span class="support">
          <app-link [to]="supportMenu.path"><lucide-icon [name]="supportMenu.icon"></lucide-icon></app-link>
          @if (supportMenu.children && supportMenu.children.length > 0) {
          <menu-dropdown [dropdownTo]="supportMenu.children"></menu-dropdown>
          }
        </span>
        } @if (isUserLoggedIn) {
        <span class="user-info" (mouseenter)="onUserInfoMouseEnter()" (mouseleave)="onUserInfoMouseLeave()">
          <lucide-icon name="circle-user-round"></lucide-icon>
          @if (isDropdownVisible) {
          <user-account-dropdown [title]="userName" [subtitle]="userMail"></user-account-dropdown>
          }
        </span>
        }
      </div>
      @if (!isUserLoggedIn) {
      <span class="user-login">
        <wpbutton to="/dashboard/login">Login</wpbutton>
      </span>
      }
    </div>
    <div class="-small-screen-hamburger-menu">
      @if (!isResponsiveNav) {
      <lucide-icon name="menu" (click)="toggleResponsiveMenu()"></lucide-icon>
      } @if (isResponsiveNav) {
      <lucide-icon id="closeHamburger" name="x" (click)="toggleResponsiveMenu()"></lucide-icon>
      }
    </div>
  </div>
</div>
}
@if (!isResponsiveNav) {
<app-inline-alert-banner></app-inline-alert-banner>
} @if (!isResponsiveNav && showSkeletonLoader) {
<docheader-secondary-nav-skeleton></docheader-secondary-nav-skeleton>
} @if (!isResponsiveNav && metadata && metadata.template && (metadata.template === 'prod-doc-page' || metadata.template
=== 'product-landing' || metadata.template === 'app-product-landing' || metadata.template === 'contact-sales' ||
metadata.template === 'doc-page' || (metadata.template === 'redoc' && metadata['secondary-nav']) || (metadata.template
=== 'sdk' && metadata['secondary-nav'])) && (metadata['secondary-nav'] || metadata['sec-nav'])) {
<div>
  <docheader-secondary-nav></docheader-secondary-nav>
</div>
} @if (!isResponsiveNav && metadata && metadata.template === 'app-api-doc' && (metadata['secondary-nav'] ||
metadata['sec-nav'])) {
<div>
  <app-docheader-secondary-nav></app-docheader-secondary-nav>
</div>
} @if (isResponsiveNav) {
<div class="-nav-container-responsive">
  @if (isSidebarPresent) { @if (metadata && metadata.template && (metadata.template ===
  globals.TEMPLATE_TYPES.API_OVERVIEW_FAMILY || metadata.template === globals.TEMPLATE_TYPES.CATEGORY)) {
  <app-sidebar
    [menu]="sidebarMetadata"
    [globalNav]="menu"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"></app-sidebar>
  } @else {
  <sidebar
    [menu]="sidebarMetadata"
    [globalNav]="menu"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"></sidebar>
  } } @else {
  <app-nav-container
    [menu]="menu"
    [supportMenu]="supportMenu"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"></app-nav-container>
  }
</div>
}
